require('../../modules/es6.object.get-own-property-descriptor');
var $Object = require('../../modules/_core').Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};



//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/~/core-js/library/fn/object/get-own-property-descriptor.js
// module id = 1283
// module chunks = 0